import { render, staticRenderFns } from "./subscribe-marketplace-item.vue?vue&type=template&id=97684ee2&"
import script from "./subscribe-marketplace-item.vue?vue&type=script&lang=js&"
export * from "./subscribe-marketplace-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports